import { Reducer } from "redux";
import { cacheManager } from "state/utils/CacheManager";
import { ConnectActionTypes, AuthenticatedSuccessPayload } from "./types";
import { connectActionTypes, ConnectState } from "./types";

export const initialState: ConnectState = {
  authenticated: false,
  theme: "light",
};

function rehydrate(): ConnectState {
  if (cacheManager.hasRecord()) {
    try {
      const cachedSettings = JSON.parse(cacheManager.getRecord());
      if (typeof cachedSettings === "object") {
        if (cachedSettings["theme"]) {
          return {
            ...initialState,
            theme: cachedSettings["theme"],
          };
        }
      }
    } catch (error) {
      return initialState;
    }
  }
  return initialState;
}

function save(index: string, data: any) {
  let cache: any;
  cache = JSON.parse(cacheManager.getRecord());
  if (typeof cache === "object") {
    cache[index] = data;
    cacheManager.setRecord(JSON.stringify(cache));
  } else {
    cacheManager.flushRecord();
  }
}

const reducer: Reducer<ConnectState, ConnectActionTypes> = (
  state = rehydrate(),
  action
) => {
  const stateCopy: ConnectState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case connectActionTypes.USER_AUTHENTICATION_SUCCESS: {
      const payload = (action as AuthenticatedSuccessPayload).payload;
      const { user } = payload;
      return {
        ...stateCopy,
        authenticated: true,
        user,
      };
    }
    case connectActionTypes.TOGGLE_THEME: {
      const theme = stateCopy.theme === "light" ? "dark" : "light";
      save("theme", theme);
      return { ...stateCopy, theme };
    }

    case connectActionTypes.USER_LOGOUT_SUCCESS: {
      return {
        ...stateCopy,
        authenticated: false,
        user: undefined,
      };
    }

    default:
      return stateCopy;
  }
};

export default reducer;
